








































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator'
import preventScroll from '@/directives/prevent-scroll'

/**
 * @component
 * @description 模态弹框，是所有弹窗的基类
 */
@Component({
  name: 'SuiPopup',
  directives: {
    preventScroll
  },
})
export default class Comp extends Vue {
  static install(vue: any) {
    vue.component((this as any).options.name, Comp)
  }

  /**
  * @prop v-model
  * @type boolean
  * @description 是否显示
  * @default false
  */
  @Prop({
    type: Boolean,
    default: false
  })
  value!: boolean

  /**
  * @prop type
  * @type string
  * @description 弹窗类型
  * @options ['center', 'bottom', 'top', 'left', 'right']
  * @default center
  */
  @Prop({
    type: String,
    default: 'center',
    validator(val) {
      return ['center', 'bottom', 'top', 'left', 'right'].indexOf(val) !== -1
    }
  })
  type!: string

  /**
  * @prop hasMask
  * @type boolean
  * @description 是否有遮罩
  * @default true
  */
  @Prop({
    type: Boolean,
    default: true
  })
  hasMask!: boolean

  /**
  * @prop transparentMask
  * @type boolean
  * @description 是否为透明遮罩
  * @default false
  */
  @Prop({
    type: Boolean,
    default: false
  })
  transparentMask!: Boolean

  /**
  * @Prop lockScroll
  * @type boolean
  * @description 基于popup的组件是否可以滑动
  * @default true
  */
  @Prop({
    type: Boolean,
    default: true
  })
  lockScroll!: boolean

  /**
  * @prop closeOnClickMask
  * @type boolean
  * @description 点击遮罩时是否关闭弹窗
  * @default true
  */
  @Prop({
    type: Boolean,
    default: true
  })
  closeOnClickMask!: boolean

  visiable = this.value

  @Watch('value')
  setVisiable(val: boolean) {
    this.visiable = val
  }

  @Emit('input')
  closePopup() {
    if (this.closeOnClickMask) {
      this.visiable = false
    }
    return this.visiable
  }
}
